module.exports = __webpack_public_path__ + "static/img/C4D0025.4c8e41b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0025.jpg
// module id = LMJe
// module chunks = 0